export default __webpack_public_path__ + "static/media/vehicle_trunk.b67c8198.svg";